import TitlesForVerification from "./routes/titles-verification/TitlesForVerification";
import PeriodicalsForVerification from "./routes/periodicals-verification/PeriodicalsForVerification";
import FrequencyConflicts from "./routes/frequency-conflicts/FrequencyConflicts";
import NewPeriodicals from "./routes/new-periodicals/NewPeriodicals";
import TitlesWithIsbn from "./routes/titles-with-isbn/TitlesWithIsbn";
import TitlesWithoutIsbn from "./routes/titles-without-isbn/TitlesWithoutIsbn";
import RequestableTitles from "./routes/requestable-titles/RequestableTitles";
import PeriodicalsManagement from "./routes/periodicals/PeriodicalsManagement";
import Publishers from "./routes/publishers/Publishers";
import Libraries from "./routes/libraries/Libraries";
import UserManagement from "./routes/users/UserManagement";
import PeriodicalChecks from "./routes/periodical-checks/PeriodicalChecks";
import { AdminPage } from "./routes/admin/AdminPage";
import { Outputs } from "./routes/outputs/Outputs";
import { RoleEnum } from "./types/RoleEnum";
import { PV_READ_ROLES } from "./types/roleSets";

export const routesConfig = {
  titlesForVerification: {
    path: "/titles-verification",
    component: TitlesForVerification,
    roles: [
      RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
      RoleEnum.ADMIN_LEGAL_DEPOSITS,
    ],
  },
  periodicalsForVerification: {
    path: "/periodicals-verification",
    component: PeriodicalsForVerification,
    roles: [
      RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
      RoleEnum.ADMIN_LEGAL_DEPOSITS,
    ],
  },
  frequencyConflicts: {
    path: "/frequency-conflicts",
    component: FrequencyConflicts,
    roles: [
      RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
      RoleEnum.ADMIN_LEGAL_DEPOSITS,
    ],
  },
  newPeriodicals: {
    path: "/new-periodicals",
    component: NewPeriodicals,
    roles: [
      RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
      RoleEnum.ADMIN_LEGAL_DEPOSITS,
    ],
  },
  periodicalChecks: {
    path: "/periodical-checks",
    component: PeriodicalChecks,
    roles: [
      RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
      RoleEnum.ADMIN_LEGAL_DEPOSITS,
    ],
  },
  titlesWithIsbn: {
    path: "/titles-with-isbn",
    component: TitlesWithIsbn,
    roles: [
      RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
      RoleEnum.ADMIN_LEGAL_DEPOSITS,
    ],
  },
  titlesWithoutIsbn: {
    path: "/titles-without-isbn",
    component: TitlesWithoutIsbn,
    roles: [
      RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
      RoleEnum.ADMIN_LEGAL_DEPOSITS,
    ],
  },
  requestableTitles: {
    path: "/requestable-titles",
    component: RequestableTitles,
    roles: [
      RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
      RoleEnum.ADMIN_LEGAL_DEPOSITS,
    ],
  },
  periodicalsManagement: {
    path: "/periodicals",
    component: PeriodicalsManagement,
    roles: [
      RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
      RoleEnum.ADMIN_LEGAL_DEPOSITS,
    ],
  },
  publishers: {
    path: "/publishers",
    component: Publishers,
    roles: PV_READ_ROLES,
  },
  libraries: {
    path: "/libraries",
    component: Libraries,
    roles: PV_READ_ROLES,
  },
  userManagement: {
    path: "/users",
    component: UserManagement,
    roles: [RoleEnum.ADMIN_LEGAL_DEPOSITS],
  },
  outputs: {
    path: "/outputs",
    component: Outputs,
    roles: [
      RoleEnum.ADMIN_LEGAL_DEPOSITS,
      RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
      RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
    ],
  },
  admin: {
    path: "/admin",
    component: AdminPage,
    roles: [RoleEnum.SUPERUSER],
  },
};
